module.exports = __webpack_public_path__ + "img/editor.1eda1e76.jpg";